/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable prefer-template */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Label } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import LoadingButton from 'components/common/LoadingButton';
import TraderSelectField from 'components/TraderSelectField';
import { KYC_STATUS_FILTER } from 'pages/Vendor/constants';
import { indiaCallingCodeId } from 'constants';

const ShareCouponCodeForm = ({
  handleSubmit,
  onCloseUpdatePopup,
  // isValid,
  // dirty,
  isSubmitting,
  values,
  // setFieldValue,
  // errors,
  // ...props
}) => {
  // console.log('touched', props, errors);
  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="Sharing Detail">
        <div className="d-flex mb-2">
          <Label>
            <b className="me-1">Indian</b>
            <Field
              type="radio"
              name="countryType"
              value="indian"
              label="Indian"
              // checked={values.countryType === 'indian'}
              // onChange={(e) => setFieldValue('countryType', e.target.value)}
              className="form-check-input"
            />
          </Label>
          <Label>
            <b className="me-1">Foreign</b>
            <Field
              type="radio"
              name="countryType"
              label="Foreign"
              value="foreign"
              // checked={values.countryType === 'foreign'}
              // onChange={(e) => setFieldValue('countryType', e.target.value)}
              className="form-check-input"
            />
          </Label>
        </div>
        <>
          <TraderSelectField
            name="vendor"
            label=""
            // type="select"
            statusFilter={{
              key: 'kycStatus',
              value: KYC_STATUS_FILTER.KYC_ACCEPTED,
              type: 'STRING',
              op: 'EQ',
            }}
            op="LIKE_OR_NOT_NULL"
            filter={[
              {
                key: 'callingCodeId',
                value: indiaCallingCodeId,
                type: 'STRING',
                op: values?.countryType === 'indian' ? 'EQ' : 'NEQ',
              },
              {
                key: 'isParentTrader',
                value: true,
                type: 'BOOLEAN',
                op: 'EQ',
              },
              // {
              //   key: 'firstName',
              //   value: '',
              //   type: 'STRING',
              //   op: 'LIKE_OR_NOT_NULL',
              // },
              // {
              //   key: 'firstName',
              //   value: '',
              //   type: 'STRING',
              //   op: 'LIKE',
              // },
            ]}
            getOptionLabel={(option) => {
              const firstName = option?.firstName || '';
              const lastName = option?.lastName || '';
              return `${firstName} ${lastName}`.trim();
            }}
            allowNewOption={false}
            isMulti
          />
          {/* {errors && (
            <div className="text-danger font-size-12">{errors?.vendor}</div>
          )} */}
        </>
        {/* <Field
          label="Select Vendor"
          name="status"
          type="select"
          component={ReactSelect}
          // loading={loading}
          data={[]}
          keys={{ id: 'id', label: 'label' }}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => {
            const firstName = option?.firstName || '';
            const lastName = option?.lastName || '';
            return `${firstName} ${lastName}`.trim();
          }}
          isClearable
          isSearchable
          // getNewOptionData={(newValue, optionLabel) => {
          //   if (newValue) {
          //     return {
          //       id: newValue,
          //       firstName: newValue,
          //     };
          //   }
          // }}
          isMulti
        /> */}
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={onCloseUpdatePopup}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          // disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          Send Email
        </LoadingButton>
      </div>
    </Form>
  );
};

export default ShareCouponCodeForm;
